var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Search as IconSearch } from "@mui/icons-material";
import { IconX } from "@tabler/icons-react";
import { useCallback, useRef } from "react";
import { UiIconButton } from "../ui_icon_button";
import { UiSpinner } from "../ui_spinner";
import { UiTextFieldV2 } from "../ui_text_field_v2";
export const UiTextFieldSearch = (_a) => {
    var { IconProps, isLoading, clearable } = _a, props = __rest(_a, ["IconProps", "isLoading", "clearable"]);
    const inputRef = useRef();
    const handleClear = useCallback(() => {
        var _a;
        const nativeInputValueSetter = (_a = Object === null || Object === void 0 ? void 0 : Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")) === null || _a === void 0 ? void 0 : _a.set;
        if (nativeInputValueSetter && inputRef.current) {
            const event = new Event("change", { bubbles: true });
            nativeInputValueSetter.call(inputRef.current, "");
            inputRef.current.dispatchEvent(event);
        }
    }, []);
    return (_jsx(UiTextFieldV2, Object.assign({ InputProps: Object.assign({ endAdornment: (() => {
                if (isLoading) {
                    return _jsx(UiSpinner, { size: 16 });
                }
                if (props.value && clearable) {
                    return (_jsx(UiIconButton, { size: "small", onClick: handleClear, children: _jsx(IconX, Object.assign({}, IconProps)) }));
                }
                return _jsx(IconSearch, Object.assign({}, IconProps));
            })() }, props.InputProps), inputRef: inputRef }, props)));
};
//# sourceMappingURL=ui_text_field_search.js.map